import { withFormik } from "formik";
import { connect } from "react-redux";
import { registerUser } from "../../../slices/authSlice";
import { RegistrationForm } from "./RegisterForm";
import * as Yup from "yup";

//constants
import {
  EMAIL_INVALID_ERROR,
  EMAIL_NOT_LONG_ERROR,
  EMAIL_REQUIRED,
  PASSWORD_REQUIRED,
  PASSWORD_SHORT_ERROR,
  CONFIRM_PASSWORD_REQUIRED,
  NAME_REQUIRED,
  PASSWORDS_MATCH_ERROR,
} from "../../../constants/messages/formMessages";

const EnhancedRegistrationForm = withFormik({
  mapPropsToValues: () => ({
    name: "",
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    // role: 'user',
    photo: "",
  }),
  validationSchema: Yup.object().shape({
    name: Yup.string().required(NAME_REQUIRED),
    email: Yup.string()
      .min(3, EMAIL_NOT_LONG_ERROR)
      .max(255)
      .email(EMAIL_INVALID_ERROR)
      .required(EMAIL_REQUIRED),
    username: Yup.string().required(),
    password: Yup.string()
      .required(PASSWORD_REQUIRED)
      .min(6, PASSWORD_SHORT_ERROR),
    confirmPassword: Yup.string()
      .required(CONFIRM_PASSWORD_REQUIRED)
      .min(6, PASSWORD_SHORT_ERROR)
      .oneOf([Yup.ref("password")], PASSWORDS_MATCH_ERROR),
    photo: Yup.string().notRequired(),
    // role: Yup.string().required(ROLE_REQUIRED),
    // publicKey: Yup.string().required(PUBLIC_KEY_REQUIRED),
  }),
  handleSubmit: (values, { setSubmitting, props }) => {
    const { registerUser, history } = props;

    registerUser(values, history);

    setSubmitting(false);
  },
  displayName: "RegistrationForm",
})(RegistrationForm);

export default connect(null, { registerUser })(EnhancedRegistrationForm);
